export const cancelInvoiceReason = [
  // { label: "01 - Comprobante emitido con errores con relación", value: "01" }, Esta razon se deja comentada por que en la operación ya no es necesaria, pero se deja por si es necesaria en su momento para el sat
  { label: "02 - Comprobante emitido con errores sin relación", value: "02" },
  { label: "03 - No se llevó a cabo la operación", value: "03" },
  { label: "04 - Operación nominativa relacionada con una factura global", value: "04" }
];
